<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const subPages = [
  {
    title: 'Dashboard',
    icon: 'ri-dashboard-line',
    color: 'primary',
    to: '/userguide/laporan/dashboard',
    desc: 'Ringkasan performa toko hari ini — sekali lihat langsung tahu kondisi bisnis.',
  },
  {
    title: 'Laporan Penjualan',
    icon: 'ri-line-chart-line',
    color: 'success',
    to: '/userguide/laporan/penjualan',
    desc: 'Analisa penjualan per hari/minggu/bulan, produk terlaris, dan metode bayar.',
  },
  {
    title: 'Laporan Inventory',
    icon: 'ri-archive-line',
    color: 'info',
    to: '/userguide/laporan/inventory',
    desc: 'Nilai stok, bahan baku yang mau habis, dan pergerakan stok masuk/keluar.',
  },
  {
    title: 'Laporan Laba Rugi',
    icon: 'ri-file-chart-line',
    color: 'warning',
    to: '/userguide/laporan/laba-rugi',
    desc: 'Untung atau rugi? Lihat rinciannya dari omzet sampai laba bersih.',
  },
]
</script>

<template>
  <div>
    <!-- Header -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center mb-4">
          <VAvatar
            color="secondary"
            variant="tonal"
            size="64"
            rounded="lg"
            class="me-4"
          >
            <VIcon icon="ri-bar-chart-box-line" size="36" />
          </VAvatar>
          <div>
            <h4 class="text-h4 font-weight-bold mb-1">
              Modul 9: Laporan
            </h4>
            <p class="text-body-1 text-medium-emphasis mb-0">
              Semua angka penting toko Anda, dalam satu tempat
            </p>
          </div>
        </div>
      </VCol>
    </VRow>

    <!-- Penjelasan Umum -->
    <VRow>
      <VCol cols="12">
        <VCard class="mb-4">
          <VCardText>
            <p class="text-body-2 mb-3">
              Modul <strong>Laporan</strong> adalah tempat Anda melihat "hasil kerja"
              toko Anda dalam bentuk angka. Bayangkan seperti buku catatan
              keuangan toko, tapi semuanya dihitung otomatis oleh sistem —
              Anda tidak perlu hitung manual pakai kalkulator atau Excel lagi.
            </p>
            <p class="text-body-2 mb-3">
              Ada 4 jenis laporan yang tersedia:
            </p>
            <ul class="text-body-2 ps-4 mb-3">
              <li class="mb-1"><strong>Dashboard</strong> — ringkasan cepat kondisi hari ini</li>
              <li class="mb-1"><strong>Laporan Penjualan</strong> — detail transaksi per periode</li>
              <li class="mb-1"><strong>Laporan Inventory</strong> — status dan nilai stok bahan baku</li>
              <li class="mb-1"><strong>Laporan Laba Rugi</strong> — untung/rugi bersih toko</li>
            </ul>

            <VAlert type="info" variant="tonal" class="mb-0">
              <strong>Estimasi waktu belajar:</strong> ± 20-30 menit untuk memahami
              semua laporan. Anda tidak perlu hafal semuanya sekaligus —
              cukup buka halaman yang Anda butuhkan saat itu.
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- List Sub Halaman -->
    <VRow>
      <VCol
        v-for="page in subPages"
        :key="page.title"
        cols="12"
        md="6"
      >
        <RouterLink :to="page.to" class="text-decoration-none">
          <VCard variant="outlined" class="h-100 report-guide-card">
            <VCardText class="d-flex align-start gap-3">
              <VAvatar :color="page.color" variant="tonal" size="48">
                <VIcon :icon="page.icon" size="26" />
              </VAvatar>
              <div>
                <h6 class="text-h6 font-weight-bold mb-1">
                  {{ page.title }}
                </h6>
                <p class="text-body-2 text-medium-emphasis mb-0">
                  {{ page.desc }}
                </p>
              </div>
            </VCardText>
          </VCard>
        </RouterLink>
      </VCol>
    </VRow>

    <!-- Catatan -->
    <VRow class="mt-2">
      <VCol cols="12">
        <VAlert type="warning" variant="tonal" icon="ri-tools-line">
          <strong>Segera hadir:</strong> Laporan Pembelian (riwayat pembelian
          ke supplier) sedang dalam pengembangan dan belum tersedia di versi ini.
        </VAlert>
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss" scoped>
.report-guide-card {
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(var(--v-theme-primary), 0.5) !important;
  }
}
</style>
